var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"figure"},[_c('iconfont',{staticClass:"cutter-loading-icon",staticStyle:{"font-size":"40px"},attrs:{"name":"#icon11-41jianjizhong"}})],1),_c('div',{staticClass:"text"},[_vm._v(" 视频添加中... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }